import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import LandingPageLeft from "./LandingPageLeft";
import LandingPageRight from "./LandingPageRight";
import "./LandingPage.css";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

function LandingPage() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  return (
    <div className="donationLandingPage" id = 'landingPage'>
      <div className="donationLandingPageContainer">
        {!isMobile && <LandingPageLeft />}
        <LandingPageRight />
        <div className="motionTextContainer">
          <div className="motionTextWrapper">
            <span className="motionText">
              Collective decision making is the future! It's time to Unite and
              Vote - NOW!
            </span>
            <span className="motionText">
              Collective decision making is the future! It's time to Unite and
              Vote - NOW!
            </span>
          </div>
        </div>
      </div>

      <div className="scrollDownContainer">
        <div className="scrollDownContainer2">
          <ArrowDownwardIcon
            sx={{ color: "white", height: "16px", width: "16px" }}
          />
          <span style={{ color: "white" }} className="scrollDownText">
            Scroll down for more feature
          </span>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
